import React from 'react';
import classnames from 'classnames';

export default function RadioButton({
  field,
  form: {touched, errors},
  label,
  isLabelBold,
  setLabelLength = false,
  value,
  style,
  ...props
}) {
  return (
    <label
      className={classnames({
        'kt-radio kt-radio--brand kt-padding-r-10': true,
        'kt-font-boldest': isLabelBold,
      })}
      style={style}
    >
      <input
        {...props}
        {...field}
        type="radio"
        name={field.name}
        value={value}
        checked={field.value === value}
      />
      {setLabelLength ? (
        <div
          style={
            props.disabled ? {opacity: '0.2', width: '75px'} : {width: '75px'}
          }
        >
          {label}
        </div>
      ) : (
        <div style={props.disabled ? {opacity: '0.8'} : {}}>{label}</div>
      )}
      <span />
    </label>
  );
}
